import { render } from "./DynamicManage.vue?vue&type=template&id=5f664508"
import script from "./DynamicManage.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/DynamicDash/DynamicManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f664508"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f664508', __exports__)) {
    api.reload('5f664508', __exports__)
  }
  
  module.hot.accept("./DynamicManage.vue?vue&type=template&id=5f664508", () => {
    api.rerender('5f664508', render)
  })

}


export default __exports__